export default __webpack_public_path__ + "static/media/nn-advance.3d31ba17.jpeg";